import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, Events, AlertController } from 'ionic-angular';
import { HttpClient } from '../../../../../services/HttpClient';

import { CustomToast } from '../../../../../util/CustomToast';

@Component({
  selector: 'page-user-publications',
  templateUrl: 'publications.html',
  providers : [HttpClient, CustomToast]
})
export class UserPublicationsPage {

  notOwnPublications = [];
  ownPublications = [];
  selectPublications = [];

  idUser;

  modalCtrl : ModalController;
	
  httpClient : HttpClient;
  searchQuery = '';
  events : Events;
  customToast : CustomToast;
  alertCtrl : AlertController;

  	constructor(public navCtrl: NavController, public navParams: NavParams, httpClient : HttpClient,modalCtrl : ModalController, events : Events, customToast : CustomToast, alertCtrl : AlertController) {
  	    this.modalCtrl = modalCtrl;
        this.httpClient = httpClient;
        this.events = events;
        this.customToast = customToast;
        this.alertCtrl = alertCtrl;
        this.idUser = this.navParams.get('idUser');

        console.log(this.idUser);

        this.events.subscribe('publication:update',()=>{
            this.httpCallPublications('',1000);
        });
        this.events.subscribe('publication:delete',()=>{
            this.httpCallPublications('',1000);
        });
        this.httpCallPublications('',1000);
  	}

    httpCallPublications(name,max){
        this.httpCallSelectPublications(name,max);
        this.httpCallOwnPublications(name,max);
        this.httpCallNotOwnPublications(name,max);
    }

    httpCallSelectPublications(name,max){ //GetNotOwnPublications
      this.httpClient.get('/publications?idUser=' + this.idUser + '&role=2&select=true&name='+name+'&max='+max,(error,data)=>{
        this.selectPublications = data.json();
      });
    }

    httpCallOwnPublications(name,max){ //GetOwnPublications
      this.httpClient.get('/publications?idUser=' + this.idUser + '&role=2&own=true&name='+name+'&max='+max,(error,data)=>{
        this.ownPublications = data.json();
      });
    }

    httpCallNotOwnPublications(name,max){ //GetNotOwnPublications
      this.httpClient.get('/publications?idUser=' + this.idUser + '&role=2&name='+name+'&max='+max,(error,data)=>{
        this.notOwnPublications = data.json();
      });
    }

    httpCallUnselectPublication(publication){
      this.httpClient.delete('/users/' + this.idUser + '/publications/'+publication.id, (error,data)=>{
        this.customToast.showMessage('Has deseleccionado la publicación correctamente.',4000);
        this.httpCallPublications('',1000);
      });
    }

    httpCallSelectPublication(publication){
      this.httpClient.post('/users/' + this.idUser + '/publications',publication, (error,data)=>{
        this.customToast.showMessage('Has seleccionado la publicación correctamente.',4000);
        this.httpCallPublications('',1000);
      });
    }

    onSearch(){
      if(this.searchQuery.length > 0){
        this.httpCallPublications(this.searchQuery,50);
      }else{
        this.httpCallPublications(this.searchQuery,1000);
      }
    }

    onClickDisable(publication){
      let alert = this.alertCtrl.create({
          title : '¿Estas seguro?',message : 'Vas a deseleccionar una publicación.',
          buttons:[{
            text : 'No',
            role : 'cancel'
            },
            {
            text : 'Si',
            role : 'confirm',
              handler : ()=>{
                this.httpCallUnselectPublication(publication);
              }
            }
          ]
        });
        alert.present();
    }

    onClickEnable(publication){
      if(this.selectPublications.length >= 5){
        this.customToast.showMessage('No puedes seleccionar más de 5 publicaciones',4000);
      }else{
        let alert = this.alertCtrl.create({
          title : '¿Estas seguro?',message : 'Vas a seleccionar una publicación.',
          buttons:[{
            text : 'No',
            role : 'cancel'
            },
            {
            text : 'Si',
            role : 'confirm',
              handler : ()=>{
                this.httpCallSelectPublication(publication);
              }
            }
          ]
        });
        alert.present();
    }
    }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/users/user/publications/publications.ts